module.exports = __webpack_public_path__ + "img/dazi_img3.d8694c58.png";